export var WIDTH = 300;
export var HEIGHT = 200;
export const PADDING = 10;

export const updatePlanarSize = (width, height) => {
    WIDTH = width;
    HEIGHT = height;
};

window.updatePlanarSize = updatePlanarSize;
